import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getListShopSuccess,
  getListShopFailed,
  GET_LIST_SHOP_START,
} from '../../actions/shop'

/**
 * get list shop pools api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListShopApi = (props) => {
  var uri = `/admin/shops`
  return api.get(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListShop(action) {
  try {
    const response = yield call(getListShopApi, action?.payload)
      yield put(getListShopSuccess(response?.data))

      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess(response?.data)
      }
  } catch (error) {
    yield put(getListShopFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list shop pools
 */
export default function* watchGetListShop() {
  yield takeLatest(GET_LIST_SHOP_START, doGetListShop)
}
